module.exports = __webpack_public_path__ + "static/media/program_pt.7e5b38fa.svg";